import http from "./http-common";

class DischargeService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) =>
        key &&
        payload[key] !== undefined &&
        payload[key] !== null &&
        payload[key] !== ""
          ? key + "=" + payload[key]
          : ""
      )
      .filter(Boolean)
      .join("&");
  }

  /**
   * GET /dischargeSummary/byPatient/:patientId
   * or GET /dischargeSummary/byAdmission/:admissionId
   */
  getDischargeSummary(payload) {
    const qs = this.queryString(payload);
    return http.get(`/dischargeSummary?${qs}`);
  }

  /**
   * GET /dischargeSummary/list/filter
   */
  getDischargeSummaryList(payload) {
    const qs = this.queryString(payload);
    return http.get(`/dischargeSummary/list/filter?${qs}`);
  }

  getDischargeById(dischSummaryId) {
    return http.get(`/dischargeSummary/${dischSummaryId}`);
  }

  saveDischargeSummary(payload) {
    return http.post("/dischargeSummary", payload);
  }

  /**
   * PUT /dischargeSummary/update/:dischargeSummaryId
   */
  DischargeUpdate(dischargeSummaryId, payload) {
    return http.put(`/dischargeSummary/update/${dischargeSummaryId}`, payload);
  }

  updateDischargeSummary(dischargeSummaryId, payload) {
    return this.DischargeUpdate(dischargeSummaryId, payload);
  }

  getDischargeTreatments(payload) {
    return http.get("/dischtreatmentmst/list/filter");
  }

  GetDischargePatientInstructionMaster(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/DischargePatientInstructionMaster/list/filter?${queryString}`);
  }

  GetDischargeDietMaster(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/DischargeDietMaster/list/filter?${queryString}`);
  }

  GetDischargeCarePlanMaster(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/DischargeCarePlanMaster/list/filter?${queryString}`);
  }

  GetDischargeDispositionMaster(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/DischargeDispositionMaster/list/filter?${queryString}`);
  }
}

export default new DischargeService();
